import axios from "axios";

export const getAddressFromCoordinates = async (latitude, longitude) => {
  return `https://www.google.com/maps?q=${latitude},${longitude}`;
  // const response = await axios.get(
  //   `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyB249oWvDs5DTvKrtvDstCQ-IJC4uDpWkg`
  // );
  // console.log(response)
  // if (response.data.results && response.data.results.length > 0) {
  //   return response.data.results[0].formatted_address;
  // } else {
  //   return "Unknown Place";
  // }
};

export const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) {
    return "-";
  }
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

// export const getTimeFromTimestamp = (timestamp) => {
//   // Convert seconds to milliseconds
//   const date = new Date(timestamp * 1000);

//   // Extract time (HH:MM:SS format)
//   return date.toLocaleTimeString("en-US", {
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     hour12: false, // Change to true for 12-hour format
//   });
// };

export function getTimeFromTimestamp(timestamp) {
  if (!timestamp) return null;

  const date = new Date(timestamp);

  const options = {
    year: "numeric",
    month: "short", // e.g. Aug
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true, // Enables AM/PM format
  };

  return date.toLocaleString("en-US", options);
}
